<template>
  <div class="activity">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>展会管理</BreadcrumbItem>
          <BreadcrumbItem>活动管理</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">活动管理</div>
        <Input
          search
          placeholder="请输入关键字"
          v-model="search"
          @on-search="searchAct"
          style="width:230px;margin-top:20px;"
        />
      </div>
      <div class="header-tool-box" v-if="showTabs==='1'">
        <div class="htb-item" @click="$router.push('/host/index/act/act-add')">
          <span class="htb-add">+</span>
          <span>新增</span>
        </div>
      </div>
    </div>

    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="活动列表" name="1">
          <hostActList
            :search="search"
            ref="hostActList"
          ></hostActList>
        </TabPane>
        <!-- <TabPane label="报名用户" name="2">
          <hostActReport
            ref="hostActReport"
          ></hostActReport>
        </TabPane> -->
      </Tabs>
    </div>
  </div>
</template>

<script>
import hostActList from "./host-activity-list.vue";
import hostActReport from "./host-activity-report.vue";

export default {
  name: "host-activity-home",
  data() {
    return {
      search: "",
      showTabs: "1",
    }
  },
  methods: {
    searchAct() {
      this.$refs.hostActList.init();
    },
    switchBrand(name) { 
      // if (name === "1") {
      //   this.$router.push(`${this.$route.path}?taype=all`);
      // } else if (name === "2") {
      //   this.$router.push(`${this.$route.path}?type=mes`);
      // } else if (name === "3") {
      //   this.$router.push(`${this.$route.path}?type=apply`);
      // }
    },
  },
  components: {
    hostActList,
    hostActReport
  }
}
</script>

<style lang="scss" scoped>

</style>